var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{ref:"CopyLink"},[_c('img',{staticClass:"icon copy",style:('width: ' + _vm.iconWidth + 'rem'),attrs:{"src":_vm.appUrl + '/img/icons/copy.svg',"alt":_vm.$t('Set.Social.copy'),"title":_vm.$t('Set.Social.copy')},on:{"click":function($event){return _vm.copyToClipboard()}}}),_c('label')])
}
var staticRenderFns = []

export { render, staticRenderFns }